var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tagsHaveBeenPreloaded
    ? _c("form", [
        _c("div", { staticClass: "dashboard-page-title" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("h1", [_vm._v("What industries are you involved in?")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-info",
                attrs: { "active-class": "" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-chevron-left" }),
                _vm._v(" Back\n      "),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "dashboard-block" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-10 col-lg-8" },
                [
                  _c("div", { staticClass: "panel panel-grey" }, [
                    _c(
                      "div",
                      { staticClass: "panel-body" },
                      [
                        _c("h3", [
                          _vm._v("What industries are you involved in?"),
                        ]),
                        _vm._v(" "),
                        _c("tags", {
                          attrs: { type: "industry" },
                          model: {
                            value: _vm.industryTags,
                            callback: function ($$v) {
                              _vm.industryTags = $$v
                            },
                            expression: "industryTags",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ladda-button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "submit",
                        click: _vm.handleSaveTagsCallback,
                      },
                    },
                    [_vm._v("\n            Save Changes\n          ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }